import Vue from 'vue'
import App from './App.vue'
import VueObserveVisibility from 'vue-observe-visibility';

import router from './router'
import 'normalize.css'
import '@/assets/css/base.css'
import axios from '@/utils/request'
import VueLazyload from 'vue-lazyload';
//process.env
console.log('环境变量---process.env',process.env);
console.log('process.env.NODE_ENV',process.env.NODE_ENV);
Vue.config.productionTip = false

Vue.use(VueLazyload, {
  preLoad: 1.5,
  error: 'error.png',
  loading: 'loading.gif',
  attempt: 1,
});

Vue.use(VueObserveVisibility);

new Vue({
  router,
  axios,
  render: h => h(App),
}).$mount('#app')
